// Single source of truth for the seller-facing Business Category icons.
// Emoji is used deliberately — Indian textile wholesalers on WhatsApp already
// recognise these glyphs, they scale cleanly across mobile + desktop, and they
// stay visually consistent across every screen that displays a BC.
export const BUSINESS_CATEGORY_ICONS = {
  'Fabric': '🧵',
  'Ladies Wear': '👗',
  "Men's Wear": '👔',
  'Girls Wear': '👧',
  'Boys Wear': '👦',
  'Furnishing': '🛋️',
};

// Fallback icon for any unknown / legacy value so nothing renders as blank.
export const bcIcon = (bc) => BUSINESS_CATEGORY_ICONS[bc] || '📦';
